/* ifreshness × zonezero trial — product description → accordions (uses existing description text only) */
(function(){
  var LABEL_RE=/^\s*[^\w\u4e00-\u9fff\(（]{0,4}\s*$/; // only emoji / symbols before the bold label
  function labelOf(p){
    if(p.tagName!=='P') return null;
    var b=p.querySelector('b,strong'); if(!b) return null;
    // text before the bold label must be emoji/blank
    var before='', n=p.firstChild;
    while(n && n!==b && !(n.contains && n.contains(b))){ before+=n.textContent||''; n=n.nextSibling; }
    if(n!==b) return null;
    if(!LABEL_RE.test(before)) return null;
    var after=''; n=b.nextSibling; while(n){ after+=n.textContent||''; n=n.nextSibling; }
    var lab=b.textContent.trim();
    if(!/^\s*[：:]/.test(after) || lab.length>14) return null;
    return {label:lab, emoji:before.trim()};
  }
  function build(desc){
    if(!desc || desc.dataset.ifrAcc) return; desc.dataset.ifrAcc='1';
    var kids=[].slice.call(desc.children), items=[], intro=[], notes=[], cur=null;
    kids.forEach(function(el){
      var l=labelOf(el);
      if(l){ cur={label:l.label,emoji:l.emoji,nodes:[el]}; items.push(cur); return; }
      var t=(el.textContent||'').trim();
      if(cur && (el.tagName==='UL'||el.tagName==='OL'||(el.tagName==='P'&&!t&&el.querySelector('img')===null&&false))){ cur.nodes.push(el); return; }
      if(!t && !el.querySelector('img,iframe')) { return; }
      if(!items.length) intro.push(el); else notes.push(el);
    });
    if(items.length<2) { delete desc.dataset.ifrAcc; return; }
    var wrap=document.createElement('div'); wrap.className='ifr-acc';
    items.forEach(function(it){
      var d=document.createElement('details'), s=document.createElement('summary'), body=document.createElement('div');
      s.textContent=(it.emoji? it.emoji+' ':'')+it.label; body.className='ifr-acc__body';
      it.nodes.forEach(function(nd,i){
        if(i===0){ // strip the "emoji <b>label</b>：" prefix, keep the rest verbatim
          var c=nd.cloneNode(true), b=c.querySelector('b,strong');
          while(c.firstChild && c.firstChild!==b && !(c.firstChild.contains && c.firstChild.contains(b))) c.removeChild(c.firstChild);
          if(b) b.remove();
          if(c.firstChild && c.firstChild.nodeType===3) c.firstChild.textContent=c.firstChild.textContent.replace(/^\s*[：:]\s*/,'');
          if((c.textContent||'').trim()) body.appendChild(c);
        } else body.appendChild(nd.cloneNode(true));
      });
      d.appendChild(s); d.appendChild(body); wrap.appendChild(d);
    });
    // shared links to existing pages (no new facts)
    [['🚚 送貨及訂購須知','詳情請參閱「送貨及訂購須知」頁面。','/pages/order-delivery','送貨及訂購須知'],
     ['💍 婚宴回禮 / 散水餅訂製','婚宴回禮及散水餅報價、訂金同貼紙設計，請參閱婚宴專頁。','/pages/wedding-series','婚宴回禮及散水餅']].forEach(function(x){
      var d=document.createElement('details'), s=document.createElement('summary'), body=document.createElement('div');
      s.textContent=x[0]; body.className='ifr-acc__body';
      var p=document.createElement('p'); p.textContent=x[1]+' '; var a=document.createElement('a'); a.href=x[2]; a.textContent=x[3]+' →'; p.appendChild(a); body.appendChild(p);
      d.appendChild(s); d.appendChild(body); wrap.appendChild(d);
    });
    // rebuild: intro stays visible, then accordions, then notes
    var frag=document.createDocumentFragment();
    intro.forEach(function(e){ frag.appendChild(e); });
    frag.appendChild(wrap);
    notes.forEach(function(e){ e.classList.add('ifr-acc__note'); frag.appendChild(e); });
    desc.innerHTML=''; desc.appendChild(frag);
    var first=wrap.querySelector('details'); if(first) first.open=true;
  }
  function run(){ [].forEach.call(document.querySelectorAll('.product__description.rte'),build); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  document.addEventListener('shopify:section:load',run);
})();

/* sticky info column that also works when the column is taller than the viewport */
(function(){
  function fit(){
    [].forEach.call(document.querySelectorAll('.product__info-container.product__column-sticky'),function(el){
      if(innerWidth<990){ el.style.removeProperty('--ifr-sticky-top'); return; }
      var h=el.offsetHeight, top=Math.min(24, innerHeight-h-(document.querySelector(".ifr-mini")?96:24));
      el.style.setProperty('--ifr-sticky-top', top+'px');
    });
  }
  function init(){
    fit(); addEventListener('resize',fit);
    if(window.ResizeObserver){ var ro=new ResizeObserver(fit); [].forEach.call(document.querySelectorAll('.product__info-container.product__column-sticky'),function(el){ ro.observe(el); }); }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* round 2 — lookbook hotspots: tap/click a dot to open its product card */
(function(){
  function closeAll(except){ [].forEach.call(document.querySelectorAll('.ifr-hs.is-open'),function(h){ if(h!==except){ h.classList.remove('is-open'); var b=h.querySelector('.ifr-hs__dot'); if(b) b.setAttribute('aria-expanded','false'); var a=h.querySelector('.ifr-hs__card'); if(a) a.tabIndex=-1; } }); }
  document.addEventListener('click',function(e){
    var dot=e.target.closest && e.target.closest('.ifr-hs__dot');
    if(dot){ var hs=dot.closest('.ifr-hs'), open=!hs.classList.contains('is-open'); closeAll(hs); hs.classList.toggle('is-open',open); dot.setAttribute('aria-expanded',open?'true':'false'); var a=hs.querySelector('.ifr-hs__card'); if(a) a.tabIndex=open?0:-1; return; }
    if(!(e.target.closest && e.target.closest('.ifr-hs__card'))) closeAll(null);
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(null); });
})();
